import { saveAs } from 'file-saver-es';
import { utils, write } from 'xlsx';
import { StockReconciliationResult, StockReconciliationRow } from '@/types';
import {
  CUSTOMER_STOCK_SOURCE_FIELDS,
  sourceFieldValue,
} from './customerStockFields';

const resultLabel = (row: StockReconciliationRow) => {
  const labels = [row.result];
  if (row.dupedInSource) labels.push('Duped in source');
  if (row.dupedInOneView) labels.push('Duped in OneView');
  return labels.join(', ');
};

export const exportStockReconciliation = (
  result: StockReconciliationResult,
  rows: StockReconciliationRow[],
) => {
  const records = rows.map((row) => {
    const record: Record<string, string> = {
      Result: resultLabel(row),
      VIN: row.vin,
    };
    CUSTOMER_STOCK_SOURCE_FIELDS.forEach((field) => {
      record[field.title] = sourceFieldValue(row.source, field) ?? '';
    });
    record['OneView Make'] = row.oneViewMake ?? '';
    record['OneView Model'] = row.oneViewModel ?? '';
    record['Year'] = row.oneViewYear ?? '';
    record['OneView Location'] = row.oneViewLocation ?? '';
    record['Arrived'] = row.oneViewArrived ?? '';
    record['Status'] = row.oneViewStatus ?? '';
    return record;
  });

  const workbook = utils.book_new();
  utils.book_append_sheet(workbook, utils.json_to_sheet(records), 'Result');
  const buffer = write(workbook, { bookType: 'xlsx', type: 'array' });
  saveAs(
    new Blob([buffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    }),
    `${result.customerName} stock reconciliation.xlsx`,
  );
};
